/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { TagDomainEnumType } from "./TagDomainEnum"
import { RootStoreType } from "./index"


/**
 * TagBase
 * auto generated base class for the model TagModel.
 */
export const TagModelBase = ModelBase
  .named('Tag')
  .props({
    __typename: types.optional(types.literal("Tag"), "Tag"),
    uuid: types.identifier,
    name: types.union(types.undefined, types.string),
    domain: types.union(types.undefined, TagDomainEnumType),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TagModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get name() { return this.__attr(`name`) }
  get domain() { return this.__attr(`domain`) }
}
export function selectFromTag() {
  return new TagModelSelector()
}

export const tagModelPrimitives = selectFromTag().uuid.name.domain
